module.exports = __webpack_public_path__ + "media/images/bf-logo-full-5ca84a892526a493e53d779f6fed55fc.svg";